import React from "react";
import style from "./OurIndustryCard.module.css";
export default function OurIndustryCard({imgSrc, text}){

    return(

        <div className={style.card_container}>
            <div>
                <img src={imgSrc} alt={text} />
            </div>
            <div>
                {text}
            </div>
        </div>
    );
}